/**
 * PartnerPromo.jsx — KYG's first official partnership (PocketBookie, started 2026-08-30).
 *
 * One file owns the whole campaign: the home-screen banner (lives in the
 * reserved announcement zone that previously ran the Sr.-submit pitch) and the
 * small card at the bottom of every results surface (ResultsScreen dailies +
 * versus, GameX won/lost). To end the campaign flip SHOW_PARTNER_PROMO to
 * false — nothing else to unwind.
 *
 * The artwork is served from storage rather than bundled, so swapping or
 * removing the image never needs a rebuild. Until the file exists at that URL
 * the results card renders nothing (onError unmounts it); the text banner up
 * top doesn't depend on it.
 */

import React, { useState } from 'react';

export const SHOW_PARTNER_PROMO = true;

const PARTNER_URL = 'https://pocketbookie.net/?ref=knowyourguy&utm_source=knowyourguy&utm_medium=referral&utm_campaign=kyg_partner';
const PARTNER_IMG = 'https://hwbuokpowygjecbujtfz.supabase.co/storage/v1/object/public/player-highlights/partners/PocketBookie.webp';

// Home-screen banner: same bordered-card chrome as the announcement slot it
// replaces. The whole card is one outbound link (new tab — never navigate
// players off KYG in place).
export function PartnerBanner() {
  const [imgDead, setImgDead] = useState(false);
  if (!SHOW_PARTNER_PROMO) return null;
  return (
    <a
      href={PARTNER_URL}
      target="_blank"
      rel="noreferrer"
      style={{
        display: 'block',
        margin: '0 0 16px 0',
        padding: '8px 12px',
        background: 'var(--bg-card)',
        borderRadius: 'var(--radius)',
        textAlign: 'center',
        textDecoration: 'none',
        cursor: 'pointer',
      }}
    >
      <div style={{ fontFamily: 'var(--font-heading)', fontSize: '9px', letterSpacing: '2px', color: 'var(--gold)', marginBottom: '5px' }}>
        OFFICIAL PARTNER OF KYG
      </div>
      {imgDead ? (
        <div style={{ fontFamily: 'var(--font-heading)', fontSize: '12px', letterSpacing: '1px', color: '#c084fc', fontWeight: 900 }}>
          POCKETBOOKIE
        </div>
      ) : (
        <img
          src={PARTNER_IMG}
          alt="PocketBookie"
          onError={() => setImgDead(true)}
          draggable={false}
          style={{ width: '160px', maxWidth: '60%', borderRadius: '6px', display: 'block', margin: '0 auto' }}
        />
      )}
      <div style={{ fontFamily: 'var(--font-body)', fontSize: '9px', letterSpacing: '0.5px', color: 'var(--text-dim)', marginTop: '4px' }}>
        An artificial intelligence company built for gamblers.
      </div>
      <div style={{ fontFamily: 'var(--font-body)', fontSize: '9px', color: 'var(--gold)', marginTop: '2px', fontWeight: 700 }}>
        Sign up for free
      </div>
    </a>
  );
}

// Results-screen card: small linked image + the code line, pinned at the very
// bottom of each results surface. Unmounts entirely if the artwork 404s.
export function PartnerPromoCard() {
  const [dead, setDead] = useState(false);
  if (!SHOW_PARTNER_PROMO || dead) return null;
  return (
    <a
      href={PARTNER_URL}
      target="_blank"
      rel="noreferrer"
      style={{ display: 'block', textAlign: 'center', marginTop: '16px', textDecoration: 'none' }}
    >
      <img
        src={PARTNER_IMG}
        alt="PocketBookie — Official Partner of KYG"
        onError={() => setDead(true)}
        draggable={false}
        style={{ width: '150px', maxWidth: '60%', borderRadius: '7px', display: 'block', margin: '0 auto' }}
      />
      <div style={{ fontFamily: 'var(--font-body)', fontSize: '9px', color: 'var(--text-dim)', marginTop: '5px' }}>
        Official Partner · <span style={{ color: 'var(--gold)', fontWeight: 700 }}>Sign up for free</span>
      </div>
    </a>
  );
}
